import { DateRangeInput, PeriodType } from '@shopify-multiseller/graphql/partner/types';

/**
 * The window every figure on the dashboard is measured over.
 *
 * The dashboard used to carry a period selector, including a custom range.
 * It does not any more: it is a summary, fixed at thirty days, so the numbers
 * on it can be read against each other without checking which range each one
 * came from. Choosing periods belongs to a reporting screen of its own.
 *
 * The shape stays because the API takes it, and because the reporting screen
 * will want the custom-range branch when it arrives.
 */
export const toDateRange = (
  period: PeriodType,
  appliedRange?: { start: string; end: string },
): DateRangeInput => ({
  periodType: period,
  ...(period === PeriodType.Custom && appliedRange ? { customRange: appliedRange } : {}),
});
